<template>
    <div>
        <div>
            <div class="mt-1">
                <FormLabel :value="$tc('messages.domains', 1)" for="category_id" />
                <FormSelect
                    id="category"
                    v-model="selected_category"
                    :options="categories"
                    class="mt-1 w-full"
                    property-name="name"
                    property-value="id"
                />
            </div>
        </div>
        <div>
            <div class="mt-1">
                <FormLabel :value="$tc('messages.dimensions', 2)" for="dimensions" />
                <div v-if="selectedCategory !== null">
                    <div class="sm:col-span-1" v-for="dimension in selectedCategory.dimensions" :key="dimension.id">
                        <div class="flex space-x-2">
                            <div>
                                <input
                                    :id="`dimension_ids_${dimension.id}`"
                                    name="dimension_ids[]"
                                    :value="dimension.id"
                                    type="checkbox"
                                    v-model="dimension_ids"
                                    class="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded"
                                />
                            </div>
                            <div>
                                <label
                                    class="block text-sm font-medium leading-5 text-gray-700"
                                    :for="`dimension_ids_${dimension.id}`"
                                    :title="dimension.description"
                                >
                                    {{ dimension.abbreviation }} -
                                    {{ dimension.title }}
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import FormSelect from '@/components/Forms/FormSelect.vue';
import FormLabel from '@/components/Forms/FormLabel.vue';

export default {
    name: 'CategoryDimensionsSelector',
    emits: ['update:modelValue', 'update:defaultCategory'],
    components: {
        FormSelect,
        FormLabel,
    },
    props: {
        categories: {
            required: true,
            type: Array,
        },
        modelValue: {
            required: true,
            type: Array,
        },
        defaultCategory: {
            required: false,
            type: [Number, String],
            default: null,
        },
    },
    computed: {
        selectedCategory: function () {
            if (!this.selected_category) {
                return null;
            }

            return this.categories.find((c) => c.id == this.selected_category);
        },
    },
    data() {
        return {
            selected_category: this.defaultCategory,
            dimension_ids: this.modelValue,
        };
    },
    watch: {
        dimension_ids(newVal) {
            this.$emit('update:modelValue', newVal);
        },
        categories() {
            this.selected_category = null;
        },
        selected_category(newVal) {
            this.$emit('update:defaultCategory', newVal);
        },
    },
};
</script>
